import { SET_SERVER_DATA_ACTION } from './ServerDataConstants';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_SERVER_DATA_ACTION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
